const isFeatureAllowed = role => {

  if (window.currentUser.role < role) {
    return false;
  }

  return true;

}

export default  isFeatureAllowed;
